<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        {{ t('group.description') }}
      </p>
    </div>
  </div>
  <drdp-report-search [multiSelectClassrooms]="true" [multiSelectSites]="true" [hasSubfilters]="true" [multiSelectRatingPeriods]="true"
    (showReportClicked)="showReport($event)" (downloadReportClicked)="downloadReport($event)"
  (clearClicked)="handleClear()" [requiredFields]="requiredFields"  [is2025]="is2025"></drdp-report-search>
  @if (!!reportData) {
    <div [innerHtml]="reportData! | safeHtml"></div>
  }
</div>

</ng-container>
